/**
 * title-search.js
 *
 * Sends storefront searches to Shopify as "title:" field searches, so only
 * product titles are matched. Per Shopify's docs, searches that use search
 * syntax also switch off semantic expansion, which is what pulls in
 * unrelated products.
 *
 * - Handles every search form that submits to the store's search URL
 *   (header modal "View all" button, results-page search box).
 * - Exposes window.titleSearch.rewrite() for predictive-search.js (Enter key).
 * - Anything that already uses search syntax is passed through untouched
 *   (id:123 OR id:456 for recently viewed, "quoted phrases", title:, AND/OR,
 *   -exclusions, wildcards).
 */
(function () {
  if (window.titleSearch) return;

  // 'AND' = every word must be in the title (Shopify's default behaviour).
  // 'OR'  = at least one word must be in the title.
  var MODE = 'OR';

  // Shopify does not index common stopwords, so they are dropped from the query.
  var STOPWORDS = ['a', 'an', 'and', 'or', 'the', 'for', 'of', 'in', 'on', 'to', 'with', 'is', 'at', 'by'];

  function rewrite(raw) {
    var q = (raw || '').trim();
    if (!q) return q;

    // Already uses search syntax? Leave it exactly as it is.
    if (/[:"*]/.test(q) || /(^|\s)-\S/.test(q) || /\s(AND|OR)\s/.test(q)) return q;

    var words = q.split(/[^\p{L}\p{N}]+/u).filter(Boolean);
    var meaningful = words.filter(function (w) {
      return STOPWORDS.indexOf(w.toLowerCase()) === -1;
    });

    // Nothing meaningful left (e.g. the query was only stopwords): don't touch it.
    if (!meaningful.length) return q;

    return meaningful
      .map(function (w) {
        return 'title:' + w;
      })
      .join(MODE === 'OR' ? ' OR ' : ' ');
  }

  function searchPath() {
    var routes = window.Theme && window.Theme.routes;
    return (routes && routes.search_url) || '/search';
  }

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!(form instanceof HTMLFormElement)) return;

    var action;
    try {
      action = new URL(form.action, location.origin);
    } catch (e) {
      return;
    }

    if (action.pathname !== new URL(searchPath(), location.origin).pathname) return;

    var input = form.querySelector('input[name="q"]');
    if (!input) return;

    var rewritten = rewrite(input.value);
    if (rewritten === input.value.trim()) return; // nothing to change, submit normally

    event.preventDefault();

    var url = new URL(action.href);
    new FormData(form).forEach(function (value, key) {
      url.searchParams.set(key, value);
    });
    url.searchParams.set('q', rewritten);
    window.location.href = url.toString();
  });

  window.titleSearch = { rewrite: rewrite };
})();